import { render } from "./TeamIndex.vue?vue&type=template&id=509cb95b"
import script from "./TeamIndex.vue?vue&type=script&lang=js"
export * from "./TeamIndex.vue?vue&type=script&lang=js"
script.render = render

export default script